module.exports = __webpack_public_path__ + "img/preferences1.e7bb18c4.svg";